<div class="jumbotron" style="background: white;">
  <div class="container text-center">
    <img src="assets/TotalEnergies_Logo_RGB.png" style="width: 350px;" />
  </div>
</div>

<nav class="navbar navbar-inverse">
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="myNavbar" style="display: block;">
      <ul class="nav navbar-nav navbar-right">
        <li class="dropdown">
          <a *ngIf="showen" href="#" class="dropdown-toggle" data-toggle="dropdown"
            style="margin-right: 10px;">Language<b class="caret"></b></a>
          <a *ngIf="showfr" href="#" class="dropdown-toggle" data-toggle="dropdown" style="margin-right: 10px;">Langue<b
              class="caret"></b></a>
          <a *ngIf="showru" href="#" class="dropdown-toggle" data-toggle="dropdown" style="margin-right: 10px;">Dil<b
              class="caret"></b></a>
          <a *ngIf="showpr" href="#" class="dropdown-toggle" data-toggle="dropdown" style="margin-right: 10px;">Língua<b
              class="caret"></b></a>
          <a *ngIf="showch" href="#" class="dropdown-toggle" data-toggle="dropdown" style="margin-right: 10px;">语言<b
              class="caret"></b></a>
          <a *ngIf="showsp" href="#" class="dropdown-toggle" data-toggle="dropdown" style="margin-right: 10px;">Idioma<b
              class="caret"></b></a>
          <a *ngIf="showar" href="#" class="dropdown-toggle" data-toggle="dropdown" style="margin-right: 10px;">لغة<b
              class="caret"></b></a>
          <a *ngIf="showde" href="#" class="dropdown-toggle" data-toggle="dropdown" style="margin-right: 10px;">Sprache<b
              class="caret"></b></a>

          <ul class="dropdown-menu">
            <li><a href="#" (click)="showdivbylanguage('en')">English</a></li>
            <li><a href="#" (click)="showdivbylanguage('fr')">French</a></li>
            <li><a href="#" (click)="showdivbylanguage('tu')">Turkisk</a></li>
            <li><a href="#" (click)="showdivbylanguage('pr')">Portuguese</a></li>
            <li><a href="#" (click)="showdivbylanguage('ch')">Chinese</a></li>
            <li><a href="#" (click)="showdivbylanguage('sp')">Spanish</a></li>
            <li><a href="#" (click)="showdivbylanguage('ar')">Arabic</a></li>
            <li><a href="#" (click)="showdivbylanguage('de')">German</a></li>

          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>

<div class="container">
  <div class="row">
    <div class="col-sm-12" style="font-family: Arial; color: #707173; background: #fff; padding: 20px;">
      <h1 *ngIf="showen">
        Thanks for scanning!<br /><br />
        The Scan TotalEnergies app is no longer available. We invite you to explore our new app, LubScan by TotalEnergies, which offers enhanced features for your convenience. <br />
        While this QR code is linked to our previous system, direct online verification is currently not available. 
        If you have any questions about the authenticity of this product, we recommend verifying it through official TotalEnergies channels or contact us by email:
        <a target="_blank" rel="noopener" href="mailto:supportlubscan@totalenergies.com">supportlubscan&#64;totalenergies.com</a>.
        <br />
      </h1>

      <h1 *ngIf="showfr">
        Merci d'avoir scanné ce QR code !<br /><br />    

        L'application Scan TotalEnergies n'est plus disponible. Nous vous invitons à découvrir LubScan by TotalEnergies, 
        notre nouvelle application, qui offre des fonctionnalités améliorées.<br />
        Veuillez noter que les anciens QR codes ne sont pas compatibles avec LubScan by TotalEnergies. 
        Si vous avez des questions concernant l'authenticité de ce produit, nous vous recommandons de le vérifier au sein du réseau TotalEnergies ou nous contacter via l'adresse mail suivante : 
        <a target="_blank" rel="noopener" href="mailto:supportlubscan@totalenergies.com">supportlubscan&#64;totalenergies.com</a>.
        <br />
      </h1>

      <h1 *ngIf="showru">
        QR kodu taradığınız için teşekkürler!<br /><br />
        
        Scan TotalEnergies uygulaması artık hizmet vermiyor. Sizi en yeni ve en gelişmiş özelliklere sahip olan uygulamamız LubScan by TotalEnergies'i keşfetmeye davet ediyoruz.<br />
        Eski QR kodlar LubScan by TotalEnergies uygulaması ile uyumlu değil. Ürünün orijinalliği hakkında herhangi bir şüpheniz varsa, 
        resmi TotalEnergies iletişim kanalları aracılığıyla veya aşağıdaki adresten müşteri hizmetleri ile iletişime geçerek doğrulamanızı öneririz: 
        <a target="_blank" rel="noopener" href="mailto:supportlubscan@totalenergies.com">supportlubscan&#64;totalenergies.com</a>.
        <br />
      </h1>

      <h1 *ngIf="showpr">
        Obrigado por escanear!<br /><br />
        
        O aplicativo Scan TotalEnergies não está mais disponível. Convidamos você a conhecer o nosso novo aplicativo, LubScan by TotalEnergies, que oferece recursos ainda mais aprimorados para sua conveniência. <br />
        Embora este QR Code esteja vinculado ao nosso sistema anterior, a verificação online direta não está disponível no momento. Se você tiver alguma dúvida sobre a autenticidade deste produto, 
        recomendamos verificá-lo por meio dos canais oficiais TotalEnergies ou entre em contato conosco por e-mail:         
        <a target="_blank" rel="noopener" href="mailto:supportlubscan@totalenergies.com">supportlubscan&#64;totalenergies.com</a>.
        <br />      
      </h1>

      <h1 style="text-align: right; direction: rtl;" *ngIf="showar">
        شكراً على مسح رمز الــ QR!<br /><br />
      
        لم يعد تطبيق Scan TotalEnergies متاحًا . ندعوك لاستكشاف تطبيقنا الجديد 
        LubScan من توتال إنرجيز، الذي يقدم مميزات محسّنة لراحتك.<br />
        علمًا بأن هذا الرمز مرتبط بنظامنا السابق، لذا فإن التحقق المباشر عبر الإنترنت غير متاح حاليًا.
        في حال وجود أي أسئلة حول صحة هذا المنتج، نوصي بالتحقق من خلال القنوات الرسمية لشركة توتال إنرجيز أو التواصل معنا عبر البريد الإلكتروني: 
        <a target="_blank" rel="noopener" href="mailto:supportlubscan@totalenergies.com">supportlubscan&#64;totalenergies.com</a>.
        <br />
      </h1>
      

      <h1 *ngIf="showch">
        感谢您的扫描！<br /><br />

        Scan TotalEnergies 应用程序已停用。 我们诚邀您使用我们的新应用程序 LubScan by TotalEnergies，它提供更强大的功能，为您带来更多便利。<br />
        请注意，之前的二维码与 LubScan by TotalEnergies 不兼容。如果您对该产品的真实性有任何疑问，我们建议您通过 TotalEnergies 官方渠道进行验证，或者通过以下邮件联系我们：

        <a target="_blank" rel="noopener" href="mailto:supportlubscan@totalenergies.com">supportlubscan&#64;totalenergies.com</a>.
        <br />
      </h1>

      <h1 *ngIf="showde">
        Danke fürs Scannen!<br /><br />
        
        Die Scan TotalEnergies App ist nicht mehr verfügbar. Wir laden Sie ein, unsere neue App LubScan by TotalEnergies zu entdecken, welche Ihnen mehr Komfort aufgrund der erweiterten Funktionen bietet. <br />
        Dieser QR-Code ist zwar mit unserem bisherigen System verknüpft, eine direkte Online-Verifizierung ist jedoch derzeit nicht möglich. Wenn Sie Fragen zur Echtheit dieses Produkts haben, empfehlen wir Ihnen, 
        es über die offiziellen TotalEnergies-Kanäle zu verifizieren oder uns unter folgender Adresse zu kontaktieren:

        <a target="_blank" rel="noopener" href="mailto:supportlubscan@totalenergies.com">supportlubscan&#64;totalenergies.com</a>.
        <br />
      </h1>
      
      <h1 *ngIf="showsp">
        ¡Gracias por escanear!<br /><br />
        
        Gracias por escanear!
        La aplicación Scan TotalEnergies ya no está disponible. Te invitamos a explorar nuestra nueva aplicación, LubScan by TotalEnergies, que ofrece características mejoradas para tu conveniencia.<br />
        Aunque este código QR está vinculado a nuestro sistema anterior, la verificación en línea directa actualmente no está disponible. Si tienes alguna pregunta sobre la autenticidad de este producto, 
        te recomendamos verificarlo a través de los canales oficiales de TotalEnergies o contactarnos por correo electrónico:              
        <a target="_blank" rel="noopener" href="mailto:supportlubscan@totalenergies.com">supportlubscan&#64;totalenergies.com</a>.
        <br />
      </h1>
    </div>
  </div>
</div>



<footer class="container-fluid text-center">
  <div class="container">
    <div class="row">
      <div class="col-md-6 text-left" style="display: flex; align-items: center;">
        <img src="assets/TE_P@SS_Logo_2.png" alt="TotalEnergies Logo" style="width: 60px; margin-right: 15px; margin-top: 17px;" />
        <p style="font-family: Arial, sans-serif; margin: 0; margin-top: 17px;">
          <b *ngIf="showen">Check-out LubScan by TotalEnergies<br> for new features</b>
          <b *ngIf="showfr">Découvrez les nouvelles fonctionnalités <br> sur LubScan by TotalEnergies !</b>
          <b *ngIf="showsp">¡Descubra las nuevas funciones de <br> LubScan by TotalEnergies! </b>
          <b style="text-align: right; direction: rtl;"*ngIf="showar"> .من توتال إنرجيز للحصول على مميزات جديدة LubScan تحقق من  </b>
          <b *ngIf="showpr">Confira as novidades no <br> LubScan by TotalEnergies! </b>
          <b *ngIf="showch"> 查看 LubScan by TotalEnergies 的新功能。 </b>
          <b *ngIf="showru"> Yeni özellikler için LubScan by TotalEnergies'i keşfedin </b>
          <b *ngIf="showde"> Die neuen Funktionen von LubScan von TotalEnergies finden Sie hier </b>
        </p>
      </div>
      <div class="col-md-6 text-right" style="display: flex; justify-content: flex-end; align-items: center;">
        <div class="col-md-12" *ngIf="showboth">
          <a target="_blank" rel="noopener" href="https://appclip.apple.com/id?p=com.totalenergies.lubscan.appclip">
            <img src="assets/IOS.png" style="width: 150px;" />
          </a>
        </div>
        <div class="col-md-12" *ngIf="showboth">
          <a target="_blank" rel="noopener"
            href="https://play.google.com/store/apps/details?id=com.totalenergies.lubscan&launch=true&scan">
            <img src="assets/Android.png" style="width: 150px;" />
          </a>
        </div>
      </div>
    </div>
    <div class="col-md-12" *ngIf="showios">
      <a target="_blank" rel="noopener" href="https://appclip.apple.com/id?p=com.totalenergies.lubscan.appclip">
        <img src="assets/IOS.png" style="width: 150px;" />
      </a>
    </div>
    <div class="col-md-12" *ngIf="showandroid">
      <a target="_blank" rel="noopener" href="https://play.google.com/store/apps/details?id=com.totalenergies.lubscan&launch=true&scan">
        <img src="assets/Android.png" style="width: 150px;margin-top: 17px;" />
      </a>
    </div>
  </div>
</footer>
